import { StreamData } from 'types/streamData'
import { Metadata } from '../adaptor/metadata'
import resolveHighlightingRelatedFields from './highlighting/highlightingUtil'
import highlightingInfosResolver from './highlighting/highlightingInfosResolver'
import { FieldResolver } from './fieldResolver'

export const highlightingRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  if (metadata.isDeleted()) {
    return {
      highlightingMaps: [] as { [key: number]: string }[]
    } as StreamData
  }

  return {
    ...resolveHighlightingRelatedFields(metadata),
    ...highlightingInfosResolver(metadata)
  }
}

export default highlightingRelatedFieldsResolver
